import { svgIconPaths } from '@/assets/svg/icons';
import CustomButton from '@/components/atoms/CustomButton';
import SvgIconThreeDots from '@/components/atoms/SvgIconThreeDots';
import colors from '@/theme/colors';
import { text } from '@/theme/colors/palettes';
import { TUserActivationToggle } from '@/types/User.types';
import {
  Popover,
  PopoverContent,
  useDisclosure,
  PopoverAnchor,
  PopoverTrigger,
  HStack,
  Center,
} from '@chakra-ui/react';
import React from 'react';

type Props = {
  user: TUserActivationToggle;
  disabled?: boolean;
  onActivate: (user: TUserActivationToggle) => void;
  onReassign: (user: TUserActivationToggle) => void;
};

const DeactivatedUsersActionsPopover = ({ user, onActivate, onReassign, disabled = false }: Props) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const hideReassignOption = user.roles?.includes('membercare') === true;

  return (
    <>
      <Popover placement={'auto'} isOpen={isOpen} onOpen={disabled ? undefined : onOpen} onClose={onClose}>
        <HStack padding={'8px'} opacity={disabled ? 0.5 : 1}>
          <PopoverAnchor>
            <HStack width={'4px'} height={'15px'} />
          </PopoverAnchor>
          <PopoverTrigger key={user.id}>
            <Center width={'35px'} marginLeft={'-10px'} cursor={'pointer'}>
              <SvgIconThreeDots color={text.mediumBlue} />
            </Center>
          </PopoverTrigger>
        </HStack>
        <PopoverContent
          bg="white"
          border={0}
          padding={'10px'}
          borderRadius={'8px'}
          boxShadow={'0px 6px 12px 0px #0E006224'}
          // width={'136px'}
          maxWidth={'220px'}
          alignItems={'center'}
        >
          <CustomButton
            isTransparent
            label={'Activate'}
            hoverBackgroundColor="primary.500"
            labelColor={colors.text.mediumBlue}
            labelHoverColor={colors.extra.white}
            iconBeforeLabelSvgPath={svgIconPaths.userActivate}
            onClick={() => {
              onActivate(user);
            }}
            height={'35px'}
            noShadow
            style={{ flex: 1 }}
          />
          {!hideReassignOption && (
            <CustomButton
              isTransparent
              label={'Reassign'}
              hoverBackgroundColor="primary.500"
              labelColor={colors.text.mediumBlue}
              labelHoverColor={colors.extra.white}
              iconBeforeLabelSvgPath={svgIconPaths.email}
              onClick={() => onReassign(user)}
              height={'35px'}
              noShadow
            />
          )}
        </PopoverContent>
      </Popover>
    </>
  );
};

export default DeactivatedUsersActionsPopover;
